import * as React from 'react';
import * as ReactDOM from 'react-dom';
import MediaQuery from 'react-responsive';
import Anchor from '@telia-front/anchor';
import Icon from '@telia-front/icon';
import { ThemeContext, } from '@telia-front/theme-provider';
import SidemenuNav from '../sidemenu-nav/sidemenu-nav';
export default class SidemenuItem extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = (event) => {
            event.preventDefault();
            if (this.props.onToggle) {
                this.props.onToggle(this.props);
            }
            if (this.props.onClick) {
                this.props.onClick(event);
            }
        };
        this.state = {
            isMounted: false,
        };
    }
    get breakpoint() {
        return this.context.breakPoints.sm;
    }
    componentDidMount() {
        this.setState({
            isMounted: true,
        });
    }
    BEM() {
        const classArray = ['sidemenu__item'];
        if (this.props.color) {
            classArray.push('sidemenu__item--' + this.props.color);
        }
        if (this.props.children) {
            classArray.push('sidemenu__item--has-children');
        }
        if (this.props.current || (this.props.children && this.props.open)) {
            classArray.push('is-current');
        }
        return classArray.join(' ');
    }
    renderSubnav() {
        if (!this.props.children) {
            return null;
        }
        return (React.createElement(SidemenuNav, { defaultTree: this.props.children, open: this.props.open, level: this.props.level ? this.props.level + 1 : 1 }));
    }
    renderIcon() {
        const icon = this.props.children ? '#arrow-down' : '#arrow-right';
        return (React.createElement(Icon, { modifiers: icon, className: "sidemenu__icon" }));
    }
    renderDynamicSubnav() {
        return (React.createElement(React.Fragment, null,
            React.createElement(MediaQuery, { minWidth: this.breakpoint }, this.renderSubnav()),
            React.createElement(MediaQuery, { maxWidth: this.breakpoint - 1 }, this.props.subContainer && ReactDOM.createPortal(this.renderSubnav(), this.props.subContainer))));
    }
    render() {
        return (React.createElement("li", { className: this.BEM(), id: this.props.id, role: "presentation" },
            React.createElement(Anchor, { url: this.props.url, className: "sidemenu__link", onClick: this.handleClick, isUnderlined: false, role: this.props.role, tabIndex: this.props.tabIndex, "aria-selected": this.props['aria-selected'] },
                this.props.label,
                this.renderIcon()),
            this.props.children && (this.state.isMounted ? this.renderDynamicSubnav() : this.renderSubnav())));
    }
}
SidemenuItem.contextType = ThemeContext;
